module.exports = {"654025100":"新源镇","654025101":"则克台镇","654025102":"阿热勒托别镇","654025103":"塔勒德镇","654025104":"那拉提镇","654025105":"肖尔布拉克镇","654025106":"喀拉布拉镇","654025107":"阿勒玛勒镇","654025108":"坎苏镇","654025200":"别斯托别乡","654025204":"吐尔根乡","654025400":"种羊场","654025403":"公安农场","654025404":"吐尔根农场","654025405":"马场","654025406":"台勒哈拉牧场","654025407":"野果林改良场","654025511":"兵团七十一团","654025512":"兵团七十二团"}


//////////////////
// WEBPACK FOOTER
// ./src/town/654025.json
// module id = 3132
// module chunks = 0